import Image1 from "../../assets/project-1.jpg";
import Image2 from "../../assets/project-2.jpg";
import Image3 from "../../assets/project-3.jpg";

const data = [
  {
    id: 1,
    category: "React / PWA",
    image: Image1,
    title: "RunPacer",
    desc: "A multi-tool running companion built with React: calculate pace, time, or distance by entering any two values, predict race times from previous results, generate per-kilometre split tables, and convert between speed units. Installable as a PWA.",
    demo: "https://runpacer.app",
    caseStudy: {
      problem: "Runners need quick access to pace, time, and distance calculations but existing tools are scattered across multiple sites or buried in bloated apps.",
      approach: "Built a focused PWA with React that handles all core running calculations in one place, with a clean single-screen UI. Used React state for live recalculation as values are typed.",
      outcome: "A lightweight installable app that works offline, loads instantly, and covers the most common calculations a runner needs before, during, and after a race.",
    },
  },
  {
    id: 2,
    category: "React / PWA",
    image: Image2,
    title: "ClearToRun",
    desc: "A personalised running weather app that scores the week ahead based on temperature, wind, humidity, and precipitation — so you always know the best window to head out. Built as a PWA with saved locations and offline support.",
    demo: "https://cleartorun.app",
    caseStudy: {
      problem: "Deciding whether conditions are good for a run requires checking multiple weather metrics: temperature, wind, rain, humidity - and mentally combining them. Generic weather apps give data, not a clear answer.",
      approach: "Designed a scoring algorithm that weights each weather factor by its impact on running comfort. Integrated an open weather API and persisted saved locations in localStorage. Packaged as a PWA for home screen installation.",
      outcome: "A single-glance 'go / no-go' score for each day of the week, removing the mental overhead of interpreting raw weather data.",
    },
  },
  {
    id: 3,
    category: "React / PWA",
    image: Image3,
    title: "RandomJoke",
    desc: "A joke-on-demand PWA with categorised joke feeds (Chuck Norris, Puns, Dark, Geeky, Holiday, and more). Users can log in to save favourites. Built with React and designed for one-tap laughs.",
    demo: "https://randomjoke.app",
    caseStudy: {
      problem: "Finding a specific type of joke quickly (without scrolling through noisy feeds or sitting through ads) is surprisingly hard.",
      approach: "Aggregated multiple joke APIs behind a single React UI, organised by category. Added user authentication so people can bookmark favourites across sessions.",
      outcome: "A fast, clean PWA that delivers categorised jokes on demand with a persistent favourites list.",
    },
  },
];

export default data;
